/* eslint-disable no-console */
import React, { useState, useEffect, useCallback } from "react"

import styled from "styled-components"

import { useLocalization } from "@izettle/lingo-client"
import { IllustrationTimerHandSvg, spacing } from "@izettle/otto"
import { Button, Illustration, Text } from "@izettle/react"

import { Disclaimer } from "@/components/disclaimer"
import { PageWrapper } from "@/components/layout-helpers"
import { redirectToBackOffice } from "@/helpers"
import { TypeOfPurposes, SellerType, Purpose, PurposesContent } from "@/models"
import { closeWebview } from "@/util"

import { PurposeList } from "./purpose-list"

const ImageContainer = styled.div`
  width: 100%;
  max-width: 227px;
  height: auto;
  margin-bottom: ${spacing.small};
`

const PageTitle = styled(Text.Title2)`
  margin: ${spacing.none} ${spacing.none} ${spacing.xxSmall};
`

const PageText = styled(Text.RegularSecondary)`
  margin: ${spacing.none} ${spacing.none} ${spacing.xxSmall};
`

const DashboardButton = styled(Button)`
  margin-top: ${spacing.xLarge};
  margin-bottom: ${spacing.xxSmall};
`

type InfoTextProps = {
  [key: string]: {
    loa: string
    mixed: string
  }
}

const infoText: InfoTextProps = {
  new: {
    loa: "THANK_YOU_TEXT",
    mixed: "THANK_YOU_TEXT",
  },
  existing: {
    loa: "THANK_YOU_TEXT_EXISTING_SELLERS_LOA",
    mixed: "THANK_YOU_TEXT_EXISTING_SELLERS_MIXED_DOCUMENTS",
  },
}

const getTypeOfPurposes = (purposes: Purpose[]): TypeOfPurposes => {
  return purposes.length === 1 &&
    purposes[0].documentPurposeType === "letterOfAuthorization"
    ? TypeOfPurposes.Loa
    : TypeOfPurposes.Mixed
}

type ThankYouProps = {
  purposes: Purpose[]
  purposesContent: PurposesContent
  sellerType: SellerType
}

export const ThankYou: React.FC<ThankYouProps> = ({
  purposes,
  purposesContent,
  sellerType,
}) => {
  const [typeOfPurposes, setTypeOfPurposes] = useState<TypeOfPurposes>(
    TypeOfPurposes.Mixed,
  )
  const { text } = useLocalization()

  useEffect(() => {
    setTypeOfPurposes(getTypeOfPurposes(purposes))
  }, [])

  const onCloseClick = useCallback(() => {
    closeWebview()
    redirectToBackOffice()
  }, [])

  return (
    <PageWrapper>
      <ImageContainer>
        <Illustration illustration={IllustrationTimerHandSvg} alt="" width="100%" height="250px" aria-hidden  />
      </ImageContainer>
      <PageTitle>{text("AUTOMATIC_PHOTOID_VERIFICATION_THANK_YOU_HEADING")}</PageTitle>
      <PageText>{text(infoText[sellerType][typeOfPurposes])}</PageText>
      <PurposeList
        purposes={purposes}
        purposesContent={purposesContent}
        sellerType={sellerType}
      />
      <DashboardButton onClick={onCloseClick}>
        {text("THANK_YOU_DASHBOARD_BUTTON")}
      </DashboardButton>
      <Disclaimer />
    </PageWrapper>
  )
}
